import { render, staticRenderFns } from "./IcoNotification.vue?vue&type=template&id=4d126269"
import script from "./IcoNotification.vue?vue&type=script&lang=js"
export * from "./IcoNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports